/**
 * Extracts card data from Jazz SDK event detail for direct card payments
 * @param {Object} eventDetail - Event detail from Jazz SDK VALID_CARD_FIELD event
 * @returns {Object} Normalized card data object
 */
function extractCardDataFromEvent(eventDetail) {
  const cardData = eventDetail?.cardData || {};

  return {
    number: cardData.maskedPan || null,
    expiry_month: cardData.expiryMonth || null,
    expiry_year: cardData.expiryYear || null,
    brand: cardData.brand || null,
    scheme: cardData.scheme || cardData.brand || null
  };
}

/**
 * Extracts card data from method object for token payments
 * @param {Object} method - Global method object containing token data
 * @returns {Object} Normalized card data object
 */
function extractCardDataFromMethod(method) {
  return {
    number: (method.bin || '') + (method.number || '') || null,
    brand: method.brand || null,
    scheme: method.brand || null,
    expiry_month: method.expiry_month || null,
    expiry_year: method.expiry_year || null
  };
}

/**
 * Checks if card data contains meaningful information
 * @param {Object} card - Card data object
 * @returns {boolean} True if card has number or brand
 */
function hasCardData(card) {
  return !!(card.number || card.brand);
}

module.exports = {
  extractCardDataFromEvent,
  extractCardDataFromMethod,
  hasCardData
};
